import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  fill2542d4m9l93pn as fill,
  VOID3gxj6tk5isa35 as VOID,
  toByte4i43936u611k as toByte,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toShort36kaw0zjdq3ex as toShort,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
  arrayCopytctsywo3h7gj as arrayCopy,
  numberToLong345n6tb1n1i71 as numberToLong,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  constructCallableReference23y65rf941mch as constructCallableReference,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
  toHexString18s73ly43cg6d as toHexString,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  toHexString22imn3z7nuei9 as toHexString_0,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
} from './kotlin-kotlin-stdlib.mjs';
import {
  SimpleRingBuffer1a4k3g2va6i8y as SimpleRingBuffer,
  getU16LE2cizldw8qp53x as getU16LE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getS32BE5aphh7sm8f2q as getS32BE,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  unsupported198cz39rr1ztw as unsupported,
  invalidOp1stebxh2m3n07 as invalidOp,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  MemorySyncStream1uv927me2xl9s as MemorySyncStream,
  write81fg3kayjaelgo as write8,
  AsyncGetLengthStream219k26r6v6js2 as AsyncGetLengthStream,
  AsyncGetPositionStream2f8n5516y4rp7 as AsyncGetPositionStream,
  openSync2m3qn99fqytu0 as openSync,
  asyncStreamWriter38isk6dcvpewr as asyncStreamWriter,
  toAsync26jtc2k5wi4gn as toAsync,
  toAsync2pa2d6thtq8t4 as toAsync_0,
  write$default3v2dul172q0c3 as write$default,
  AsyncOutputStreamkoco1dsjo5gm as AsyncOutputStream,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  ASCII_getInstance1ki74j81tlqzy as ASCII_getInstance,
  toString2x583ovdqfjci as toString_0,
} from './korlibs-string-root-korlibs-string.mjs';
import { runBlockingNoSuspensions25hsuevf2mle as runBlockingNoSuspensions } from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  CRC32_getInstance17wjtebi624vh as CRC32_getInstance,
  Adler32_instancesz6nr31w650j as Adler32_instance,
} from './korlibs-checksum-root-korlibs-checksum.mjs';
import { extract2vhru1ihy4ogl as extract } from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var clz32 = Math.clz32;
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    this.hbb_1 = 8388608;
    this.ibb_1 = 131072;
  }
}
class Companion_0 {
  constructor() {
    this.jbb_1 = -1;
    this.kbb_1 = -2;
    this.lbb_1 = 1023;
    this.mbb_1 = 16;
    this.nbb_1 = 288;
    this.obb_1 = true;
    this.pbb_1 = true;
    this.qbb_1 = 10;
  }
}
class SlidingWindowWithOutput {
  constructor(sliding, out, flushSize, extraSize) {
    flushSize = flushSize === VOID ? 8388608 : flushSize;
    extraSize = extraSize === VOID ? 131072 : extraSize;
    this.dbc_1 = sliding;
    this.ebc_1 = out;
    this.fbc_1 = flushSize;
    this.gbc_1 = extraSize;
    this.hbc_1 = FixedSizeByteArrayBuilder.kbc(this.fbc_1 + this.gbc_1 | 0);
  }
  lbc() {
    return this.hbc_1.jbc_1 >= this.fbc_1;
  }
  mbc(distance, length) {
    var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = this.dbc_1.rbc(distance);
        this.hbc_1.waz(toByte(v));
      }
       while (inductionVariable < length);
  }
  sbc(bytes, offset, len) {
    this.hbc_1.uaz(bytes, offset, len);
    this.dbc_1.tbc(bytes, offset, len);
  }
  ubc(byte) {
    this.hbc_1.waz(byte);
    this.dbc_1.vbc(get_unsigned(byte));
  }
}
class CompressionMethod {}
function *uncompress(i, o, $completion) {
  unsupported();
}
class IDeflaterInternal {}
function *uncompress_0(i, o, $completion) {
  yield* this.gbd(toDeflater(new BitReader(i)), toDeflater_0(o), $completion);
  return Unit_instance;
}
class DeflaterPortable {
  constructor(windowBits) {
    Companion_getInstance_1();
    this.fbd_1 = windowBits;
  }
  *gbd(reader, out, $completion) {
    var sout = new SlidingWindowWithOutput(new SlidingWindow(this.fbd_1), out, reader.qbd(), reader.rbd());
    var lastBlock = false;
    var tempTree = new HuffmanTree();
    var tempDist = new HuffmanTree();
    var codeLenCodeLen = new Int32Array(32);
    var lengths = new Int32Array(512);
    while (!lastBlock) {
      // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
      if (false || sout.lbc()) {
        // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
        yield* sout.ebc_1.ib6(sout.hbc_1.ibc_1, 0, sout.hbc_1.jbc_1, $completion);
        sout.hbc_1.a5();
      }
      yield* reader.sbd($completion);
      lastBlock = reader.nbd();
      var blockType = reader.tbd(2);
      if (!(0 <= blockType ? blockType <= 2 : false)) {
        // Inline function 'kotlin.error' call
        var message = 'invalid bit';
        throw IllegalStateException.o(toString(message));
      }
      if (blockType === 0) {
        var len = reader.ubd();
        var nlen = reader.ubd();
        var nnlen = ~nlen & 65535;
        if (!(len === nnlen)) {
          // Inline function 'kotlin.error' call
          var message_0 = 'Invalid deflate stream: len(' + len + ') != ~nlen(' + nnlen + ') :: nlen=' + nlen;
          throw IllegalStateException.o(toString(message_0));
        }
        var bytes = yield* reader.vbd(len, $completion);
        sout.sbc(bytes, 0, len);
        // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
        if (false || sout.lbc()) {
          // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
          yield* sout.ebc_1.ib6(sout.hbc_1.ibc_1, 0, sout.hbc_1.jbc_1, $completion);
          sout.hbc_1.a5();
        }
      } else {
        var tree;
        var dist;
        if (blockType === 1) {
          tree = Companion_getInstance_1().xbc_1;
          dist = Companion_getInstance_1().ybc_1;
        } else {
          var hlit = reader.tbd(5) + 257 | 0;
          var hdist = reader.tbd(5) + 1 | 0;
          var hclen = reader.tbd(4) + 4 | 0;
          fill(codeLenCodeLen, 0);
          var inductionVariable = 0;
          if (inductionVariable < hclen)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              codeLenCodeLen[Companion_getInstance_1().dbd_1[i]] = reader.tbd(3);
            }
             while (inductionVariable < hclen);
          tempTree.ebd(codeLenCodeLen);
          var codeLen = tempTree;
          var hlithdist = hlit + hdist | 0;
          var n = 0;
          fill(lengths, 0);
          while (n < hlithdist) {
            // Inline function 'korlibs.compression.deflate.DeflaterPortable.read' call
            var value = codeLen.ibd(reader);
            if (!(0 <= value ? value <= 18 : false)) {
              // Inline function 'kotlin.error' call
              throw IllegalStateException.o(toString('Invalid'));
            }
            var len_0;
            switch (value) {
              case 16:
                len_0 = reader.tbd(2) + 3 | 0;
                break;
              case 17:
                len_0 = reader.tbd(3) + 3 | 0;
                break;
              case 18:
                len_0 = reader.tbd(7) + 11 | 0;
                break;
              default:
                len_0 = 1;
                break;
            }
            var vv;
            switch (value) {
              case 16:
                vv = lengths[n - 1 | 0];
                break;
              case 17:
                vv = 0;
                break;
              case 18:
                vv = 0;
                break;
              default:
                vv = value;
                break;
            }
            fill(lengths, vv, n, n + len_0 | 0);
            n = n + len_0 | 0;
          }
          tempTree.obd(lengths, 0, hlit);
          tempDist.obd(lengths, hlit, hlithdist);
          tree = tempTree;
          dist = tempDist;
        }
        $l$loop: while (true) {
          yield* reader.sbd($completion);
          var value_0 = tree.ibd(reader);
          if (value_0 === 256)
            break $l$loop;
          if (value_0 < 256) {
            sout.ubc(toByte(value_0));
          } else {
            var zlenof = value_0 - 257 | 0;
            var lengthExtra = reader.tbd(Companion_getInstance_1().zbc_1[zlenof]);
            // Inline function 'korlibs.compression.deflate.DeflaterPortable.read' call
            var distanceData = dist.ibd(reader);
            var distanceExtra = reader.tbd(Companion_getInstance_1().bbd_1[distanceData]);
            var distance = Companion_getInstance_1().cbd_1[distanceData] + distanceExtra | 0;
            var length = Companion_getInstance_1().abd_1[zlenof] + lengthExtra | 0;
            sout.mbc(distance, length);
          }
          // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
          if (false || sout.lbc()) {
            // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
            yield* sout.ebc_1.ib6(sout.hbc_1.ibc_1, 0, sout.hbc_1.jbc_1, $completion);
            sout.hbc_1.a5();
          }
        }
      }
    }
    // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
    if (true || sout.lbc()) {
      // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
      yield* sout.ebc_1.ib6(sout.hbc_1.ibc_1, 0, sout.hbc_1.jbc_1, $completion);
      sout.hbc_1.a5();
    }
    return Unit_instance;
  }
}
class Companion_1 extends DeflaterPortable {
  constructor() {
    Companion_instance_1 = null;
    super(15);
    Companion_instance_1 = this;
    var tmp = this;
    var tmp_0 = new HuffmanTree();
    // Inline function 'kotlin.apply' call
    var this_0 = new Int32Array(288);
    var inductionVariable = 0;
    if (inductionVariable <= 143)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0[n] = 8;
      }
       while (inductionVariable <= 143);
    var inductionVariable_0 = 144;
    if (inductionVariable_0 <= 255)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_0[n_0] = 9;
      }
       while (inductionVariable_0 <= 255);
    var inductionVariable_1 = 256;
    if (inductionVariable_1 <= 279)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        this_0[n_1] = 7;
      }
       while (inductionVariable_1 <= 279);
    var inductionVariable_2 = 280;
    if (inductionVariable_2 <= 287)
      do {
        var n_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        this_0[n_2] = 8;
      }
       while (inductionVariable_2 <= 287);
    tmp.xbc_1 = tmp_0.ebd(this_0);
    var tmp_1 = this;
    var tmp_2 = new HuffmanTree();
    var tmp_3 = 0;
    var tmp_4 = new Int32Array(32);
    while (tmp_3 < 32) {
      tmp_4[tmp_3] = 5;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_1.ybc_1 = tmp_2.ebd(tmp_4);
    var tmp_5 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_5.zbc_1 = new Int32Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0]);
    var tmp_6 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_6.abd_1 = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]);
    var tmp_7 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_7.bbd_1 = new Int32Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
    var tmp_8 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_8.cbd_1 = new Int32Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]);
    var tmp_9 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_9.dbd_1 = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
  }
}
class HuffmanTree {
  constructor() {
    this.rbb_1 = new Int32Array(1024);
    this.sbb_1 = new Int32Array(1024);
    this.tbb_1 = new Int32Array(1024);
    this.ubb_1 = 0;
    this.vbb_1 = 1023;
    this.wbb_1 = 0;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = new Int32Array(1024);
    while (tmp_0 < 1024) {
      tmp_1[tmp_0] = -1;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.xbb_1 = tmp_1;
    var tmp_2 = this;
    var tmp_3 = 0;
    var tmp_4 = new Int32Array(1024);
    while (tmp_3 < 1024) {
      tmp_4[tmp_3] = 0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_2.ybb_1 = tmp_4;
    this.zbb_1 = new Int32Array(17);
    this.abc_1 = new Int32Array(17);
    this.bbc_1 = new Int32Array(17);
    this.cbc_1 = new Int32Array(288);
  }
  ibd(reader) {
    reader.jbd(10);
    var node = this.vbb_1;
    if (true && reader.mbd() >= 10) {
      var bits = reader.kbd(10);
      var raw = this.xbb_1[bits];
      var value = toShort(raw);
      var len = raw >> 16;
      if (len > 0) {
        reader.lbd(len);
        if (value === -2) {
          node = this.ybb_1[bits];
        } else {
          return value;
        }
      }
    }
    $l$1: do {
      $l$0: do {
        var tmp;
        if (reader.nbd()) {
          // Inline function 'korlibs.compression.deflate.HuffmanTree.right' call
          var this_0 = node;
          tmp = this.tbb_1[this_0];
        } else {
          // Inline function 'korlibs.compression.deflate.HuffmanTree.left' call
          var this_1 = node;
          tmp = this.sbb_1[this_1];
        }
        node = tmp;
      }
       while (false);
      var tmp_0;
      if (!(node === 1023)) {
        // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
        var this_2 = node;
        tmp_0 = this.rbb_1[this_2] === -1;
      } else {
        tmp_0 = false;
      }
    }
     while (tmp_0);
    // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
    var this_3 = node;
    return this.rbb_1[this_3];
  }
  obd(codeLengths, start, end) {
    var oldOffset = 0;
    var oldCount = 0;
    var ncodes = end - start | 0;
    resetAlloc(this);
    fill(this.zbb_1, 0);
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var codeLen = codeLengths[n];
        if (!(0 <= codeLen ? codeLen <= 16 : false)) {
          // Inline function 'kotlin.error' call
          var message = 'Invalid HuffmanTree.codeLengths ' + codeLen;
          throw IllegalStateException.o(toString(message));
        }
        var _array__4zh2yp = this.zbb_1;
        _array__4zh2yp[codeLen] = _array__4zh2yp[codeLen] + 1 | 0;
      }
       while (inductionVariable < end);
    var currentOffset = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < 16)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var count = this.zbb_1[n_0];
        this.abc_1[n_0] = currentOffset;
        this.bbc_1[n_0] = currentOffset;
        currentOffset = currentOffset + count | 0;
      }
       while (inductionVariable_0 < 16);
    var inductionVariable_1 = start;
    if (inductionVariable_1 < end)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var codeLen_0 = codeLengths[n_1];
        var _array__4zh2yp_0 = this.bbc_1;
        var _unary__edvuaz = _array__4zh2yp_0[codeLen_0];
        _array__4zh2yp_0[codeLen_0] = _unary__edvuaz + 1 | 0;
        this.cbc_1[_unary__edvuaz] = n_1 - start | 0;
      }
       while (inductionVariable_1 < end);
    var inductionVariable_2 = 16;
    if (1 <= inductionVariable_2)
      do {
        var i = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + -1 | 0;
        var newOffset = this.ubb_1;
        var OFFSET = this.abc_1[i];
        var SIZE = this.zbb_1[i];
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < SIZE)
          do {
            var j = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            allocLeaf(this, this.cbc_1[OFFSET + j | 0]);
          }
           while (inductionVariable_3 < SIZE);
        var progression = step(until(0, oldCount), 2);
        var inductionVariable_4 = progression.n3_1;
        var last = progression.o3_1;
        var step_0 = progression.p3_1;
        if (step_0 > 0 && inductionVariable_4 <= last || (step_0 < 0 && last <= inductionVariable_4))
          do {
            var j_0 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + step_0 | 0;
            allocNode(this, oldOffset + j_0 | 0, (oldOffset + j_0 | 0) + 1 | 0);
          }
           while (!(j_0 === last));
        oldOffset = newOffset;
        oldCount = SIZE + (oldCount / 2 | 0) | 0;
        if (oldCount >= 2 && !((oldCount % 2 | 0) === 0)) {
          // Inline function 'kotlin.error' call
          var message_0 = 'This canonical code does not represent a Huffman code tree: ' + oldCount;
          throw IllegalStateException.o(toString(message_0));
        }
      }
       while (1 <= inductionVariable_2);
    if (!(oldCount === 2)) {
      // Inline function 'kotlin.error' call
      var message_1 = 'This canonical code does not represent a Huffman code tree';
      throw IllegalStateException.o(toString(message_1));
    }
    this.vbb_1 = allocNode(this, this.ubb_1 - 2 | 0, this.ubb_1 - 1 | 0);
    this.wbb_1 = ncodes;
    computeFastLookup(this);
    return this;
  }
  ebd(codeLengths, start, end, $super) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? codeLengths.length : end;
    return $super === VOID ? this.obd(codeLengths, start, end) : $super.obd.call(this, codeLengths, start, end);
  }
}
class SlidingWindow {
  constructor(nbits) {
    this.nbc_1 = nbits;
    this.obc_1 = new Int8Array(1 << this.nbc_1);
    this.pbc_1 = this.obc_1.length - 1 | 0;
    this.qbc_1 = 0;
  }
  u2(offset) {
    return this.obc_1[(this.qbc_1 - offset | 0) & this.pbc_1] & 255;
  }
  rbc(offset) {
    return this.vbc(this.u2(offset));
  }
  vbc(value) {
    this.obc_1[this.qbc_1] = toByte(value);
    this.qbc_1 = (this.qbc_1 + 1 | 0) & this.pbc_1;
    return value;
  }
  tbc(bytes, offset, len) {
    var inductionVariable = 0;
    if (inductionVariable < len)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.vbc(get_unsigned(bytes[offset + n | 0]));
      }
       while (inductionVariable < len);
  }
}
class FixedSizeByteArrayBuilder {
  constructor(data) {
    return new.target.pbd(data);
  }
  static pbd(data) {
    var $this = createThis(this);
    $this.ibc_1 = data;
    $this.jbc_1 = 0;
    return $this;
  }
  static kbc(size) {
    return this.pbd(new Int8Array(size));
  }
  a5() {
    this.jbc_1 = 0;
  }
  uaz(array, offset, len) {
    arraycopy(array, offset, this.ibc_1, this.jbc_1, len);
    this.jbc_1 = this.jbc_1 + len | 0;
  }
  waz(v) {
    var _unary__edvuaz = this.jbc_1;
    this.jbc_1 = _unary__edvuaz + 1 | 0;
    this.ibc_1[_unary__edvuaz] = v;
  }
}
class Companion_2 {
  constructor() {
    this.wbd_1 = 8388608;
    this.xbd_1 = 32768;
  }
}
class BitReader {
  constructor(s, bigChunkSize, readWithSize) {
    bigChunkSize = bigChunkSize === VOID ? 8388608 : bigChunkSize;
    readWithSize = readWithSize === VOID ? 32768 : readWithSize;
    this.ybd_1 = s;
    this.zbd_1 = bigChunkSize;
    this.abe_1 = readWithSize;
    this.bbe_1 = 0;
    this.cbe_1 = 0;
    this.dbe_1 = new SimpleRingBuffer(ilog2(get_nextPowerOfTwo(this.zbd_1)));
    this.ebe_1 = 0.0;
    this.fbe_1 = 0.0;
    this.gbe_1 = new Int8Array(4);
  }
  toString() {
    return 'BitReader(' + toString(this.ybd_1) + ', bigChunkSize=' + this.zbd_1 + ', readWithSize=' + this.abe_1 + ')';
  }
  hbe() {
    return this.dbe_1.gb3_1 < this.abe_1;
  }
  *ibe(expectedBytes, $completion) {
    $l$loop_0: while (this.dbe_1.gb3_1 < expectedBytes) {
      // Inline function 'kotlin.math.min' call
      var b = this.dbe_1.ya9();
      var readCount = Math.min(expectedBytes, b);
      if (readCount <= 0)
        break $l$loop_0;
      var transferred = yield* this.ybd_1.kb6(this.dbe_1.sa9(), this.dbe_1.ua9(), readCount, $completion);
      if (transferred <= 0)
        break $l$loop_0;
      this.dbe_1.va9(transferred);
      this.fbe_1 = this.fbe_1 + transferred;
    }
    return Unit_instance;
  }
  jbd(bitcount) {
    while (this.cbe_1 < bitcount) {
      var tmp = this;
      var tmp_0 = this.bbe_1;
      // Inline function 'korlibs.compression.deflate.BitReader._su8' call
      this.ebe_1 = this.ebe_1 + 1;
      tmp.bbe_1 = tmp_0 | this.dbe_1.j72() << this.cbe_1;
      this.cbe_1 = this.cbe_1 + 8 | 0;
    }
  }
  kbd(bitcount) {
    return this.bbe_1 & ((1 << bitcount) - 1 | 0);
  }
  lbd(bitcount) {
    this.bbe_1 = this.bbe_1 >>> bitcount | 0;
    this.cbe_1 = this.cbe_1 - bitcount | 0;
  }
  tbd(bitcount) {
    this.jbd(bitcount);
    var readed = this.kbd(bitcount);
    this.lbd(bitcount);
    return readed;
  }
  nbd() {
    return !(this.tbd(1) === 0);
  }
  jbe(count, out) {
    var offset = 0;
    var count_0 = count;
    if (this.cbe_1 >= 8) {
      if (!((this.cbe_1 % 8 | 0) === 0)) {
        var bits = this.cbe_1 % 8 | 0;
        this.lbd(bits);
      }
      while (this.cbe_1 >= 8) {
        var byte = toByte(this.tbd(8));
        var _unary__edvuaz = offset;
        offset = _unary__edvuaz + 1 | 0;
        out[_unary__edvuaz] = byte;
        count_0 = count_0 - 1 | 0;
      }
    }
    // Inline function 'korlibs.compression.deflate.BitReader.discardBits' call
    this.bbe_1 = 0;
    this.cbe_1 = 0;
    var readCount = this.dbe_1.ob3(out, offset, count_0);
    if (readCount > 0)
      this.ebe_1 = this.ebe_1 + readCount;
  }
  kbe(count, out) {
    this.jbe(count, out);
    return out;
  }
  lbe() {
    // Inline function 'korlibs.compression.deflate.BitReader.discardBits' call
    this.bbe_1 = 0;
    this.cbe_1 = 0;
    // Inline function 'korlibs.compression.deflate.BitReader._su8' call
    this.ebe_1 = this.ebe_1 + 1;
    return this.dbe_1.j72();
  }
  ubd() {
    this.jbe(2, this.gbe_1);
    return getU16LE(this.gbe_1, 0);
  }
  mbe() {
    this.jbe(4, this.gbe_1);
    return getS32LE(this.gbe_1, 0);
  }
  nbe() {
    this.jbe(4, this.gbe_1);
    return getS32BE(this.gbe_1, 0);
  }
  *obe(count, out, $completion) {
    yield* this.ibe(count, $completion);
    return this.kbe(count, out);
  }
  pbe(count, out, $completion, $super) {
    out = out === VOID ? new Int8Array(count) : out;
    return $super === VOID ? this.obe(count, out, $completion) : $super.obe.call(this, count, out, $completion);
  }
  *kb6(buffer, offset, len, $completion) {
    yield* this.ibe(len, $completion);
    var out = this.dbe_1.ob3(buffer, offset, len);
    this.ebe_1 = this.ebe_1 + out;
    return out;
  }
  *lb6($completion) {
    yield* this.ybd_1.lb6($completion);
    return Unit_instance;
  }
  *qbe($completion) {
    // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
    var buffer = ByteArrayBuilder.taz(4096);
    var s = MemorySyncStream(buffer);
    // Inline function 'korlibs.compression.deflate.BitReader.discardBits' call
    this.bbe_1 = 0;
    this.cbe_1 = 0;
    $l$loop: while (true) {
      // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
      if (this.hbe())
        yield* this.ibe(this.zbd_1, $completion);
      // Inline function 'korlibs.compression.deflate.BitReader._su8' call
      this.ebe_1 = this.ebe_1 + 1;
      var c = this.dbe_1.j72();
      if (c === 0)
        break $l$loop;
      write8(s, c);
    }
    var tmp$ret$0 = buffer.xaz();
    return toString_0(tmp$ret$0, ASCII_getInstance());
  }
  *tb8($completion) {
    return numberToLong(this.ebe_1);
  }
  *qb8($completion) {
    var tmp = this.ybd_1;
    var tmp2_safe_receiver = isInterface(tmp, AsyncGetLengthStream) ? tmp : null;
    var tmp0_elvis_lhs = tmp2_safe_receiver == null ? null : (yield* tmp2_safe_receiver.qb8($completion));
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  *pb8($completion) {
    var tmp = this.ybd_1;
    var tmp3_safe_receiver = isInterface(tmp, AsyncGetLengthStream) ? tmp : null;
    var tmp0_elvis_lhs = tmp3_safe_receiver == null ? null : (yield* tmp3_safe_receiver.pb8($completion));
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Length not available on Stream';
      throw IllegalStateException.o(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
}
class toDeflater$1 {
  constructor($this_toDeflater) {
    this.rbe_1 = $this_toDeflater;
  }
  qbd() {
    return this.rbe_1.zbd_1;
  }
  rbd() {
    return this.rbe_1.abe_1;
  }
  mbd() {
    return this.rbe_1.cbe_1;
  }
  jbd(bits) {
    return this.rbe_1.jbd(bits);
  }
  *vbd(count, $completion) {
    return yield* this.rbe_1.pbe(count, VOID, $completion);
  }
  ubd() {
    return this.rbe_1.ubd();
  }
  nbd() {
    return this.rbe_1.nbd();
  }
  lbd(bits) {
    return this.rbe_1.lbd(bits);
  }
  kbd(count) {
    return this.rbe_1.kbd(count);
  }
  tbd(count) {
    return this.rbe_1.tbd(count);
  }
  *sbd($completion) {
    // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
    var this_0 = this.rbe_1;
    if (this_0.hbe())
      yield* this_0.ibe(this_0.zbd_1, $completion);
    return Unit_instance;
  }
}
class toDeflater$2 {
  constructor($this_toDeflater) {
    this.sbe_1 = $this_toDeflater;
  }
  *ib6(bytes, offset, size, $completion) {
    return yield* this.sbe_1.ib6(bytes, offset, size, $completion);
  }
}
class GZIPBase {
  constructor(checkCrc, deflater) {
    this.tbe_1 = checkCrc;
    this.ube_1 = deflater;
  }
  toString() {
    return 'GZIPBase(' + this.tbe_1 + ', ' + toString(this.ube_1) + ')';
  }
  *hbd(i, out, $completion) {
    var r = new BitReader(i);
    // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
    if (r.hbe())
      yield* r.ibe(r.zbd_1, $completion);
    var h0 = r.lbe();
    var h1 = r.lbe();
    if (!(h0 === 31) || !(h1 === 139)) {
      // Inline function 'kotlin.error' call
      var message = 'Not a GZIP file (h0=' + toHexString(toByte(h0)) + ', h1=' + toHexString(toByte(h1)) + ')';
      throw IllegalStateException.o(toString(message));
    }
    var method = r.lbe();
    if (!(method === 8)) {
      // Inline function 'kotlin.error' call
      var message_0 = 'Just supported deflate in GZIP (method=' + method + ')';
      throw IllegalStateException.o(toString(message_0));
    }
    var ftext = r.nbd();
    var fhcrc = r.nbd();
    var fextra = r.nbd();
    var fname = r.nbd();
    var fcomment = r.nbd();
    var reserved = r.tbd(3);
    var mtime = r.mbe();
    var xfl = r.lbe();
    var os = r.lbe();
    var tmp;
    if (fextra) {
      tmp = yield* r.pbe(r.ubd(), VOID, $completion);
    } else {
      // Inline function 'kotlin.byteArrayOf' call
      tmp = new Int8Array([]);
    }
    var extra = tmp;
    var name = fname ? (yield* r.qbe($completion)) : null;
    var comment = fcomment ? (yield* r.qbe($completion)) : null;
    var crc16 = fhcrc ? r.ubd() : 0;
    var ccrc32 = {_v: CRC32_getInstance().fbb_1};
    var csize = {_v: 0};
    var tmp_0 = this.ube_1();
    var tmp_1 = isInterface(tmp_0, IDeflaterInternal) ? tmp_0 : THROW_CCE();
    var tmp_2 = toDeflater(r);
    yield* tmp_1.gbd(tmp_2, toDeflater_0(new GZIPBase$uncompress$2(out, ccrc32, csize)), $completion);
    // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
    if (r.hbe())
      yield* r.ibe(r.zbd_1, $completion);
    var crc32 = r.mbe();
    var size = r.mbe();
    if (this.tbe_1 && (!(csize._v === size) || !(ccrc32._v === crc32))) {
      invalidOp("Size doesn't match SIZE(" + toHexString_0(csize._v) + ' != ' + toHexString_0(size) + ') || CRC32(' + toHexString_0(ccrc32._v) + ' != ' + toHexString_0(crc32) + ')');
    }
    return Unit_instance;
  }
}
class GZIP extends GZIPBase {
  constructor(deflater) {
    Companion_getInstance_3();
    super(true, deflater);
  }
}
class Companion_3 extends GZIP {
  constructor() {
    Companion_instance_3 = null;
    super(GZIP$Companion$_init_$lambda_4zsoc7);
    Companion_instance_3 = this;
  }
  toString() {
    return 'GZIP';
  }
}
class GZIPBase$uncompress$2 {
  constructor($out, $ccrc32, $csize) {
    this.wbe_1 = $out;
    this.xbe_1 = $ccrc32;
    this.ybe_1 = $csize;
    this.vbe_1 = $out;
  }
  *lb6($completion) {
    yield* this.vbe_1.lb6($completion);
    return Unit_instance;
  }
  *ib6(buffer, offset, len, $completion) {
    if (len > 0) {
      this.xbe_1._v = CRC32_getInstance().ebb(this.xbe_1._v, buffer, offset, len);
      this.ybe_1._v = this.ybe_1._v + len | 0;
      yield* this.wbe_1.ib6(buffer, offset, len, $completion);
    }
    return Unit_instance;
  }
}
class ZLib {
  constructor(deflater) {
    Companion_getInstance_4();
    this.zbe_1 = deflater;
  }
  *hbd(i, o, $completion) {
    var r = new BitReader(i);
    // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
    if (r.hbe())
      yield* r.ibe(r.zbd_1, $completion);
    var cmf = r.lbe();
    var flg = r.lbe();
    if (!(((imul(cmf, 256) + flg | 0) % 31 | 0) === 0)) {
      // Inline function 'kotlin.error' call
      var message = 'bad zlib header';
      throw IllegalStateException.o(toString(message));
    }
    var compressionMethod = extract(cmf, 0, 4);
    if (!(compressionMethod === 8)) {
      // Inline function 'kotlin.error' call
      var message_0 = 'Invalid zlib stream compressionMethod=' + compressionMethod;
      throw IllegalStateException.o(toString(message_0));
    }
    var windowBits = extract(cmf, 4, 4) + 8 | 0;
    var fcheck = extract(flg, 0, 5);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var hasDict = !(((flg >>> 5 | 0) & 1) === 0);
    var flevel = extract(flg, 6, 2);
    var dictid = 0;
    if (hasDict) {
      dictid = r.mbe();
      // Inline function 'kotlin.TODO' call
      var reason = 'Unsupported custom dictionaries (Provided DICTID=' + dictid + ')';
      throw NotImplementedError.le('An operation is not implemented: ' + reason);
    }
    var chash = {_v: Adler32_instance.dbb_1};
    var tmp = this.zbe_1(windowBits);
    var tmp_0 = isInterface(tmp, IDeflaterInternal) ? tmp : THROW_CCE();
    var tmp_1 = toDeflater(r);
    yield* tmp_0.gbd(tmp_1, toDeflater_0(new ZLib$uncompress$2(o, chash)), $completion);
    // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
    if (r.hbe())
      yield* r.ibe(r.zbd_1, $completion);
    var adler32 = r.nbe();
    if (!(chash._v === adler32)) {
      invalidOp("Adler32 doesn't match " + toHexString_0(chash._v) + ' != ' + toHexString_0(adler32));
    }
    return Unit_instance;
  }
}
class Companion_4 extends ZLib {
  constructor() {
    Companion_instance_4 = null;
    super(ZLib$Companion$_init_$lambda_nrgg4o);
    Companion_instance_4 = this;
  }
}
class ZLib$uncompress$2 {
  constructor($o, $chash) {
    this.abf_1 = $o;
    this.bbf_1 = $chash;
  }
  *lb6($completion) {
    return yield* this.abf_1.lb6($completion);
  }
  *ib6(buffer, offset, len, $completion) {
    yield* this.abf_1.ib6(buffer, offset, len, $completion);
    this.bbf_1._v = Adler32_instance.ebb(this.bbf_1._v, buffer, offset, len);
    return Unit_instance;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function resetAlloc($this) {
  $this.ubb_1 = 0;
}
function alloc($this, value, left, right) {
  var _unary__edvuaz = $this.ubb_1;
  $this.ubb_1 = _unary__edvuaz + 1 | 0;
  // Inline function 'kotlin.apply' call
  $this.rbb_1[_unary__edvuaz] = value;
  $this.sbb_1[_unary__edvuaz] = left;
  $this.tbb_1[_unary__edvuaz] = right;
  return _unary__edvuaz;
}
function allocLeaf($this, value) {
  return alloc($this, value, 1023, 1023);
}
function allocNode($this, left, right) {
  return alloc($this, -1, left, right);
}
function computeFastLookup($this) {
  fill($this.xbb_1, -1);
  computeEncodedValues($this, $this.vbb_1, 0, 0);
}
function computeEncodedValues($this, node, encoded, encodedBits) {
  // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
  if ($this.rbb_1[node] === -1) {
    if (encodedBits < 10) {
      // Inline function 'korlibs.compression.deflate.HuffmanTree.left' call
      var tmp$ret$1 = $this.sbb_1[node];
      computeEncodedValues($this, tmp$ret$1, encoded, encodedBits + 1 | 0);
      // Inline function 'korlibs.compression.deflate.HuffmanTree.right' call
      var tmp$ret$2 = $this.tbb_1[node];
      computeEncodedValues($this, tmp$ret$2, encoded | 1 << encodedBits, encodedBits + 1 | 0);
    } else {
      writeVariants($this, encoded, encodedBits, node, -2);
    }
  } else {
    // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
    var tmp$ret$3 = $this.rbb_1[node];
    writeVariants($this, encoded, encodedBits, node, tmp$ret$3);
  }
}
function writeVariants($this, encoded, encodedBits, node, nvalue) {
  var encodedInfo = nvalue & 65535 | encodedBits << 16;
  var rangeCount = 1 << (10 - encodedBits | 0);
  var inductionVariable = 0;
  if (inductionVariable < rangeCount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var i = encoded | n << encodedBits;
      $this.xbb_1[i] = encodedInfo;
      $this.ybb_1[i] = node;
    }
     while (inductionVariable < rangeCount);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function get_unsigned(_this__u8e3s4) {
  return _this__u8e3s4 & 255;
}
function arraycopy(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
function toDeflater(_this__u8e3s4) {
  return new toDeflater$1(_this__u8e3s4);
}
function toDeflater_0(_this__u8e3s4) {
  return new toDeflater$2(_this__u8e3s4);
}
function ilog2(v) {
  var tmp;
  if (v === 0) {
    tmp = -1;
  } else {
    // Inline function 'kotlin.countLeadingZeroBits' call
    tmp = 31 - clz32(v) | 0;
  }
  return tmp;
}
function get_nextPowerOfTwo(_this__u8e3s4) {
  var v = _this__u8e3s4;
  v = v - 1 | 0;
  v = v | v >> 1;
  v = v | v >> 2;
  v = v | v >> 4;
  v = v | v >> 8;
  v = v | v >> 16;
  v = v + 1 | 0;
  return v;
}
function uncompress_1(_this__u8e3s4, method, outputSizeHint) {
  outputSizeHint = outputSizeHint === VOID ? imul(_this__u8e3s4.length, 2) : outputSizeHint;
  return uncompress_2(method, _this__u8e3s4, outputSizeHint);
}
function *uncompressed(_this__u8e3s4, method, bufferSize, $completion) {
  bufferSize = bufferSize === VOID ? 8388608 : bufferSize;
  return yield* uncompressStream(method, _this__u8e3s4, bufferSize, $completion);
}
function uncompress_2(_this__u8e3s4, bytes, outputSizeHint) {
  outputSizeHint = outputSizeHint === VOID ? imul(bytes.length, 2) : outputSizeHint;
  // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
  var buffer = ByteArrayBuilder.taz(outputSizeHint);
  var s = MemorySyncStream(buffer);
  uncompress_3(_this__u8e3s4, openSync(bytes), s);
  return buffer.xaz();
}
function *uncompressStream(_this__u8e3s4, input, bufferSize, $completion) {
  bufferSize = bufferSize === VOID ? 8388608 : bufferSize;
  var tmp = 'uncompress:' + toString(_this__u8e3s4);
  return yield* asyncStreamWriter(bufferSize, tmp, false, uncompressStream$slambda(_this__u8e3s4, input), $completion);
}
function uncompress_3(_this__u8e3s4, i, o) {
  return runBlockingNoSuspensions(uncompress$slambda(_this__u8e3s4, i, o));
}
function uncompressStream$slambda($this_uncompressStream, $input) {
  return constructCallableReference(function *(output, $completion) {
    yield* $this_uncompressStream.hbd($input, output, $completion);
    return Unit_instance;
  }, 1);
}
function uncompress$slambda($this_uncompress, $i, $o) {
  return constructCallableReference(function *($completion) {
    yield* $this_uncompress.hbd(toAsync($i), toAsync_0($o), $completion);
    return Unit_instance;
  }, 0);
}
function get_Deflate() {
  _init_properties_Deflate_kt__jbr9mv();
  var tmp0 = Deflate$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('Deflate', 0, tmp, _get_Deflate_$ref_5609qt(), null);
  return tmp0.k3();
}
var Deflate$delegate;
function Deflate(windowBits) {
  _init_properties_Deflate_kt__jbr9mv();
  return DeflaterNative(windowBits);
}
function Deflate$delegate$lambda() {
  _init_properties_Deflate_kt__jbr9mv();
  return Deflate(15);
}
function _get_Deflate_$ref_5609qt() {
  return constructCallableReference(() => get_Deflate(), 0, 0, 81);
}
var properties_initialized_Deflate_kt_5ek8zp;
function _init_properties_Deflate_kt__jbr9mv() {
  if (!properties_initialized_Deflate_kt_5ek8zp) {
    properties_initialized_Deflate_kt_5ek8zp = true;
    Deflate$delegate = lazy(Deflate$delegate$lambda);
  }
}
function GZIP$Companion$_init_$lambda_4zsoc7() {
  return get_Deflate();
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function ZLib$Companion$_init_$lambda_nrgg4o(it) {
  return Deflate(it);
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function DeflaterNative(windowBits) {
  return new DeflaterPortable(windowBits);
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
initMetadataForClass(SlidingWindowWithOutput, 'SlidingWindowWithOutput', VOID, VOID, VOID, [0, 1]);
initMetadataForInterface(CompressionMethod, 'CompressionMethod', VOID, VOID, VOID, [2, 3]);
initMetadataForInterface(IDeflaterInternal, 'IDeflaterInternal', VOID, VOID, [CompressionMethod], [2, 3]);
protoOf(DeflaterPortable).hbd = uncompress_0;
initMetadataForClass(DeflaterPortable, 'DeflaterPortable', VOID, VOID, [IDeflaterInternal], [3, 2]);
initMetadataForCompanion(Companion_1, VOID, VOID, [3, 2]);
initMetadataForClass(HuffmanTree, 'HuffmanTree', HuffmanTree);
initMetadataForClass(SlidingWindow, 'SlidingWindow');
initMetadataForClass(FixedSizeByteArrayBuilder, 'FixedSizeByteArrayBuilder');
initMetadataForCompanion(Companion_2, VOID, VOID, [1]);
initMetadataForClass(BitReader, 'BitReader', VOID, VOID, [AsyncGetPositionStream, AsyncGetLengthStream], [0, 1, 2, 3]);
initMetadataForClass(toDeflater$1, VOID, VOID, VOID, VOID, [0, 1, 3]);
initMetadataForClass(toDeflater$2, VOID, VOID, VOID, VOID, [3, 1]);
initMetadataForClass(GZIPBase, 'GZIPBase', VOID, VOID, [CompressionMethod], [2, 3]);
initMetadataForClass(GZIP, 'GZIP', VOID, VOID, VOID, [2, 3]);
initMetadataForCompanion(Companion_3, VOID, VOID, [2, 3]);
protoOf(GZIPBase$uncompress$2).jb6 = write$default;
initMetadataForClass(GZIPBase$uncompress$2, VOID, VOID, VOID, [AsyncOutputStream], [1, 0, 3]);
initMetadataForClass(ZLib, 'ZLib', VOID, VOID, [CompressionMethod], [2, 3]);
initMetadataForCompanion(Companion_4, VOID, VOID, [2, 3]);
protoOf(ZLib$uncompress$2).jb6 = write$default;
initMetadataForClass(ZLib$uncompress$2, VOID, VOID, VOID, [AsyncOutputStream], [0, 3, 1]);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_2 = new Companion_2();
//endregion
//region block: exports
export {
  Companion_getInstance_3 as Companion_getInstance34rsdhmwl8tit,
  Companion_getInstance_4 as Companion_getInstancee7wpm1ix3t3y,
  uncompressed as uncompressed2z67snkddol6y,
  get_Deflate as get_Deflate2a0lyute7oxjd,
  uncompress_1 as uncompress3ofkd276wd0zn,
};
//endregion
